import { render, staticRenderFns } from "./pc-address.vue?vue&type=template&id=5d7df806&scoped=true"
import script from "./pc-address.vue?vue&type=script&lang=ts"
export * from "./pc-address.vue?vue&type=script&lang=ts"
import style0 from "./pc-address.vue?vue&type=style&index=0&id=5d7df806&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7df806",
  null
  
)

export default component.exports